export default "__VITE_ASSET__PQ6yudnw__"